import React, { useState } from "react";
import MulitFileUpload from "../components/MulitFileUpload";
import SingleFileUpload from "../components/SingleFileUpload";
import { addImages, addProduct, createFolderCloud, destoryCloud, uploadCloud } from "../../../../api/Products";
import LoadingSpinner from "../../../../components/LoadingSpinner";
import { UPLOAD_PRESETS_CLOUDINARY } from "../../../../api";
import { useNavigate } from "react-router-dom";

const ArrayFormItem = ({ title, inputName, onChange }) => {
  const [value, setValue] = useState("");
  const [array, setArray] = useState([]);

  const handleAddToArray = () => {
    if (value.trim()) {
      setArray([...array, value]);
      setValue("");
      onChange(inputName, [...array, value]); // Notify parent of change
    }
  };

  const handleDeleteFromArray = (indexToDelete) => {
    const newArray = array.filter((_, index) => index !== indexToDelete);
    setArray(newArray);
    onChange(inputName, newArray); // Notify parent of change
  };

  return (
    <div className="w-full mx-auto">
      <label
        htmlFor={inputName}
        className="block mb-2 text-sm font-medium text-gray-900"
      >
        {title}
      </label>
      <ul>
        {array.map((item, index) => (
          <li
            key={index}
            className="flex justify-between items-center bg-blue-800 text-white rounded px-5 py-2 mb-2"
          >
            {item}
            <button
              type="button"
              onClick={() => handleDeleteFromArray(index)}
              className="text-red-600 hover:text-red-900"
            >
              <i className="fa-solid fa-trash"></i>
            </button>
          </li>
        ))}
      </ul>
      <div className="flex w-full">
        <button
          type="button"
          onClick={handleAddToArray}
          className="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border border-e-0 border-gray-300 rounded-s-md"
        >
          <i className="fa-solid fa-circle-plus"></i>
        </button>
        <input
          type="text"
          id={inputName}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          className="rounded-none rounded-e-lg bg-gray-50 border border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm p-2.5"
          placeholder="Enter value"
        />
      </div>
    </div>
  );
};



const ArrayFieldOfApplication = ({ title, inputName, onChange ,options = [
    "General Imaging",
    "Obstetrics and Gynecology",
    "Cardiovascular",
    "Point of Care",
  ] }) => {
  const [array, setArray] = useState([]);
  const [selected, setSelected] = useState("");



  const handleAddToArray = () => {
    if (selected && !array.includes(selected)) {
      const newArray = [...array, selected];
      setArray(newArray);
      setSelected("");
      onChange(inputName, newArray); // Notify parent of change
    }
  };

  const handleDeleteFromArray = (indexToDelete) => {
    const newArray = array.filter((_, index) => index !== indexToDelete);
    setArray(newArray);
    onChange(inputName, newArray); // Notify parent of change
  };

  return (
    <div className="w-full mx-auto">
      <label
        htmlFor={inputName}
        className="block mb-2 text-sm font-medium text-gray-900"
      >
        {title}
      </label>
      <ul>
        {array.map((item, index) => (
          <li
            key={index}
            className="flex justify-between items-center bg-blue-800 text-white rounded px-5 py-2 mb-2"
          >
            {item}
            <button
              type="button"
              onClick={() => handleDeleteFromArray(index)}
              className="text-red-600 hover:text-red-900"
            >
              <i className="fa-solid fa-trash"></i>
            </button>
          </li>
        ))}
      </ul>
      <div className="flex w-full">
        <select
          id={inputName}
          value={selected}
          onChange={(e) => setSelected(e.target.value)}
          className="rounded-none rounded-e-lg bg-gray-50 border border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm p-2.5"
        >
          <option value="">Select option</option>
          {options.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>
        <button
          type="button"
          onClick={handleAddToArray}
          className="inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border border-e-0 border-gray-300 rounded-s-md"
        >
          <i className="fa-solid fa-circle-plus"></i>
        </button>
      </div>
    </div>
  );
};


const SpecsArray = ({ title, inputName, onChange, setMainSpec }) => {
  const [specs, setSpecs] = useState([]);
  const [currentSpec, setCurrentSpec] = useState("");
  const [currentChildKey, setCurrentChildKey] = useState("");
  const [currentChildValue, setCurrentChildValue] = useState("");

  const handleAddToSpecs = () => {
    if (currentSpec.trim()) {
      const newSpecs = [...specs, { [currentSpec]: [] }];
      setSpecs(newSpecs);
      setCurrentSpec("");
      onChange(inputName, newSpecs); // Notify parent of change
    }
  };

  const handleAddChildSpecs = (index, specKey) => {
    if (currentChildKey.trim() && currentChildValue.trim()) {
      const updatedSpecs = specs.map((spec, i) =>
        i === index
          ? {
              ...spec,
              [specKey]: [
                ...(spec[specKey] || []),
                { [currentChildKey]: currentChildValue },
              ],
            }
          : spec
      );
      setSpecs(updatedSpecs);
      setCurrentChildKey("");
      setCurrentChildValue("");
      onChange(inputName, updatedSpecs); // Notify parent of change
    }
  };

  const handleDeleteFromSpecs = (index) => {
    const newSpecs = specs.filter((_, i) => i !== index);
    setSpecs(newSpecs);
    onChange(inputName, newSpecs); // Notify parent of change
  };

  const handleDeleteChildSpecs = (specIndex, specKey, childIndex) => {
    const updatedSpecs = specs.map((spec, i) => {
      if (i === specIndex) {
        const updatedChildSpecs = spec[specKey].filter(
          (_, cIndex) => cIndex !== childIndex
        );
        return { ...spec, [specKey]: updatedChildSpecs };
      }
      return spec;
    });
    setSpecs(updatedSpecs);
    onChange(inputName, updatedSpecs); // Notify parent of change
  };

  return (
    <div className="w-full mx-auto">
      <label
        htmlFor="specs"
        className="block mb-2 text-sm font-medium text-gray-900"
      >
        {title}
      </label>
      <input
        type="text"
        onChange={(e) => setMainSpec("mainspec", e.target.value)}
        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 mb-4"
        placeholder="Enter main specification"
      />
      <ul>
        {specs.map((spec, index) => {
          const specKey = Object.keys(spec)[0];
          return (
            <li
              key={index}
              className="flex flex-col bg-blue-800 text-white rounded px-5 py-2 mb-2"
            >
              <div className="flex justify-between items-center mb-2">
                <span>{specKey}</span>
                <button
                  type="button"
                  onClick={() => handleDeleteFromSpecs(index)}
                  className="text-red-600 hover:text-red-900"
                >
                  <i className="fa-solid fa-trash"></i>
                </button>
              </div>
              {spec[specKey].length > 0 && (
                <ul>
                  {spec[specKey].map((child, childIndex) => {
                    const childKey = Object.keys(child)[0];
                    return (
                      <li
                        key={childIndex}
                        className="flex justify-between items-center bg-white text-blue-900 rounded px-5 py-2 mb-2"
                      >
                        <span>
                          {childKey}: {child[childKey]}
                        </span>
                        <button
                          type="button"
                          onClick={() =>
                            handleDeleteChildSpecs(index, specKey, childIndex)
                          }
                          className="text-red-600 hover:text-red-900"
                        >
                          <i className="fa-solid fa-trash"></i>
                        </button>
                      </li>
                    );
                  })}
                </ul>
              )}
              <div className="flex flex-col mt-2">
                <div className="flex mb-2">
                  <input
                    type="text"
                    value={currentChildKey}
                    onChange={(e) => setCurrentChildKey(e.target.value)}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full  p-2.5"
                    placeholder="Enter child key"
                  />
                  <input
                    type="text"
                    value={currentChildValue}
                    onChange={(e) => setCurrentChildValue(e.target.value)}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full p-2.5 ml-2"
                    placeholder="Enter child value"
                  />
                  <button
                    type="button"
                    onClick={() => handleAddChildSpecs(index, specKey)}
                    className="inline-flex items-center px-3 mx-2 text-sm text-gray-900 bg-gray-200 border border-gray-300 rounded-md hover:bg-gray-300"
                  >
                    <i className="fa-solid fa-circle-plus mr-2"></i>
                    Add Child
                  </button>
                </div>
              </div>
            </li>
          );
        })}
      </ul>
      <div className="flex w-full mt-4">
        <input
          type="text"
          value={currentSpec}
          onChange={(e) => setCurrentSpec(e.target.value)}
          className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm p-2.5"
          placeholder="Enter specification"
        />
        <button
          type="button"
          onClick={handleAddToSpecs}
          className="ml-2 inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border border-gray-300 rounded-md hover:bg-gray-300"
        >
          <i className="fa-solid fa-circle-plus mr-2"></i>
          Add
        </button>
      </div>
    </div>
  );
};

const ArrayFileLink = ({ itemTitle, inputName, onChange }) => {
  const [title, setTitle] = useState("");
  const [pdfUrl, setPdfUrl] = useState("");
  const [size, setSize] = useState("");
  const [array, setArray] = useState([]);

  const handleAddToArray = () => {
    if (title.trim() && pdfUrl.trim() && size.trim()) {
      const newArray = [...array, { title, pdfUrl, size }];
      setArray(newArray);
      setTitle("");
      setPdfUrl("");
      setSize("");
      onChange(inputName, newArray); // Notify parent of change
    }
  };

  const handleDeleteFromArray = (indexToDelete) => {
    const newArray = array.filter((_, index) => index !== indexToDelete);
    setArray(newArray);
    onChange(inputName, newArray); // Notify parent of change
  };

  return (
    <div className="w-full mx-auto">
      <label
        htmlFor="fileLinks"
        className="block mb-2 text-sm font-medium text-gray-900"
      >
        {itemTitle}
      </label>
      <ul>
        {array.map((item, index) => (
          <li
            key={index}
            className="flex justify-between items-center bg-blue-800 text-white rounded px-5 py-2 mb-2"
          >
            {item.title} - {item.size}
            <button
              type="button"
              onClick={() => handleDeleteFromArray(index)}
              className="text-red-600 hover:text-red-900"
            >
              <i className="fa-solid fa-trash"></i>
            </button>
          </li>
        ))}
      </ul>
      <div className="flex w-full">
        <input
          type="text"
          onChange={(e) => setTitle(e.target.value)}
          className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm p-2.5"
          placeholder="Enter file name"
        />
        <input
          type="text"
          onChange={(e) => setPdfUrl(e.target.value)}
          className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm p-2.5 ml-2"
          placeholder="Enter file link"
        />
        <input
          type="text"
          onChange={(e) => setSize(e.target.value)}
          className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm p-2.5 ml-2"
          placeholder="Enter file size"
        />
        <button
          type="button"
          onClick={handleAddToArray}
          className="ml-2 inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border border-gray-300 rounded-md hover:bg-gray-300"
        >
          <i className="fa-solid fa-circle-plus mr-2"></i>
          Add
        </button>
      </div>
    </div>
  );
};

const AddProduct = () => {
  const [formData, setFormData] = useState({
    name: "",
    subname: "",
    describe: "",
    benifits: [],
    features: [],
    pros: [],
    clinicalSegments: [],
    fields: [],
    mainspec: "",
    specs: [],
    fileLinks: [],
  });

  const [images, setImages] = useState([]);

  const [loading, setLoading] = useState(false);
  const Navigate = useNavigate();
  const handleArrayChange = (key, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [key]: value, // Use computed property name to update the key dynamically
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    // console.log("Form Data:", formData);


    setLoading(true);
    // console.log("requist")

    const uploadPromises = images.map(async (image) => {
      const form = new FormData();
      form.append("upload_preset", UPLOAD_PRESETS_CLOUDINARY);
      form.append("file", image);
      form.append("folder", "test");
    
      const uploadedImage = await uploadCloud(form); 
      console.log(uploadedImage.data);
      return uploadedImage.data;
    });

    const uploadedUrls = await Promise.all(uploadPromises);
    const uploadedObjects = uploadedUrls.map((upload) => ({
      url: upload.secure_url,
      public_id: upload.public_id,
      signuture: upload.signature
    }));
    console.log(uploadedObjects)
    const requistHandle = {
      name: formData.name,
      subName: formData.subname,
      description: {
        describe: formData.describe,
        benefits: formData.benifits,
      },
      feature: formData.features,
      pros: formData.pros,
      images:uploadedObjects,
      clinicalSegments: {
        segments: formData.clinicalSegments,
        fieldOfApplication: formData.fields,
      },
      document: formData.fileLinks,
      specifications: [
        { mainSpec: formData.mainspec },
        { specs: formData.specs },
      ],
    };
    console.log(requistHandle);
    const res = await addProduct(requistHandle);
    console.log(res);
    // requistHandle.images = [...uploadedUrls];
    // console.log("after requist");

    // const createFolder = await createFolderCloud(requistHandle.name);
    // console.log(createFolder);
    

    // form.append("cloud", UPLOAD_PRESETS_CLOUDINARY);
    
    // const sendImages = await addImages(form, res._id);
    // console.log(sendImages);
    Navigate("/dashboard/main/product");

    setLoading(false);
  };

  // delete images so now we will need to store images like that images : [{public_id:"public_id", image " url"}]
  const handleDelete = async(public_id) =>{
    const res = await destoryCloud(public_id)
    console.log(res)
  }

  return (
    <>
      <h3 className="mx-auto p-5">add product form</h3>
      <hr className="my-5" />
      {/* <button onClick={()=>handleDelete("dasdasd")} type="button">Delete</button> */}

      <form className="max-w-full mx-auto" onSubmit={handleSubmit}>
        <div className="flex md:flex-row flex-col items-start justify-between w-full ">
          <div className="flex flex-col items-start justify-center  p-5 w-full md:w-3/5">
            <div className="flex md:flex-row flex-col items-start gap-4 w-full">
              <div className="w-full">
                <label
                  htmlFor="name"
                  className="block mb-2 text-sm font-medium text-gray-900"
                  onChange={(e) => {
                    handleArrayChange("name", e.target.value);
                  }}
                >
                  name
                </label>
                <input
                  type="text"
                  id="name"
                  aria-describedby="helper-text-explanation"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                  placeholder="product name"
                  onChange={(e) => {
                    handleArrayChange("name", e.target.value);
                  }}
                />
              </div>
              <div className="w-full">
                <label
                  htmlFor="name"
                  className="block mb-2 text-sm font-medium text-gray-900"
                >
                  sub-name
                </label>
                <input
                  type="text"
                  id="name"
                  aria-describedby="helper-text-explanation"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                  placeholder="product sub name"
                  onChange={(e) => {
                    handleArrayChange("subname", e.target.value);
                  }}
                />
              </div>
            </div>
            <div className=" w-full mt-5">
              <label
                htmlFor="message"
                className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
              >
                Description
              </label>
              <textarea
                id="message"
                rows="4"
                className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
                placeholder="Product Description"
                onChange={(e) => {
                  handleArrayChange("describe", e.target.value);
                }}
              ></textarea>
            </div>
            <div className=" w-full mt-5">
              <SingleFileUpload setImages={setImages} />
              <br />
              <MulitFileUpload setImages={setImages} />
            </div>
          </div>
          <div className="flex md:w-2/5 w-full p-5 bg-gray-100">
            <div className="w-full">
              <ArrayFormItem
                title={"benifits"}
                inputName={"benifits"}
                onChange={handleArrayChange}
              />
            </div>
          </div>
        </div>

        <hr className="my-5" />

        <div className="flex md:flex-row flex-col items-start justify-between w-full ">
          <div className="flex md:w-1/2 w-full p-5">
            <div className="w-full">
              <ArrayFormItem
                title={"features"}
                inputName={"features"}
                onChange={handleArrayChange}
              />
            </div>
          </div>

          <div className="flex md:w-1/2 w-full p-5 ">
            <div className="w-full">
              <ArrayFormItem
                title={"pros"}
                inputName={"pros"}
                onChange={handleArrayChange}
              />
            </div>
          </div>
        </div>

        <hr className="my-5" />

        <div className="flex md:flex-row flex-col items-start justify-between w-full ">
          <div className="flex md:w-1/2 w-full p-5">
            <div className="w-full">
              <ArrayFormItem
                title={"Clinical Segments"}
                inputName={"clinicalSegments"}
                onChange={handleArrayChange}
              />
            </div>
          </div>

          <div className="flex md:w-1/2 w-full p-5 ">
            <div className="w-full">
              {/* <ArrayFormItem
                title={"Field Of Application"}
                inputName={"fields"}
                onChange={handleArrayChange}
              /> */}
              <ArrayFieldOfApplication
                title={"Field Of Application"}
                inputName={"fields"}
                onChange={handleArrayChange}
              />
            </div>
          </div>
        </div>

        <hr className="my-5" />

        <ArrayFileLink
          itemTitle={"documents"}
          inputName={"fileLinks"}
          onChange={handleArrayChange}
        />
        <hr className="my-5" />
        <SpecsArray
          title={"specs"}
          inputName={"specs"}
          onChange={handleArrayChange}
          setMainSpec={handleArrayChange}
        />

        <hr className="my-5" />
        {loading ? (
          <button 
          className="text-white w-full bg-gradient-to-r from-cyan-500 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
          
          >
            <LoadingSpinner/>
          </button>
        ) : (
          <input
            type="submit"
            value={"add product"}
            className="text-white w-full bg-gradient-to-r from-cyan-500 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-cyan-300 dark:focus:ring-cyan-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
          />
        )}

        {/* <input type="submit"></input> */}
      </form>
    </>
  );
};

export default AddProduct;
